import {
  UpdateUserRequest,
  updateUserRequestOutputTransformer,
} from '../interfaces/User/UpdateUserRequest';
import api, { apiPrefix } from './Api';

export const updateUser = async (
  id: number,
  req: UpdateUserRequest,
): Promise<void> =>
  api.post(
    `${apiPrefix}/users/${id}/update`,
    updateUserRequestOutputTransformer(req),
  );
